import React, { useState } from "react";
import { PublicShell } from "./PublicShell";
import { SITE } from "@/constants/site";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Apa itu Sistem Informasi Keuangan Al-Khoir?",
    a: "Ini adalah platform resmi Pondok Pesantren Al-Khoir untuk mengelola pembayaran biaya pendidikan santri, uang jajan santri, tabungan santri, serta transaksi koperasi pesantren (Kopontren) secara daring.",
  },
  {
    q: "Bagaimana cara login ke aplikasi?",
    a: "Orang tua/wali dapat masuk menggunakan Nomor HP dan kata sandi yang telah didaftarkan oleh admin pesantren. Jika lupa kata sandi, silakan hubungi admin pesantren.",
  },
  {
    q: "Metode pembayaran apa saja yang tersedia?",
    a: "Pembayaran dapat dilakukan melalui QRIS, Virtual Account (transfer bank), dan e-wallet, sesuai metode yang aktif pada payment gateway kami.",
  },
  {
    q: "Apakah pembayaran saya aman?",
    a: "Ya. Seluruh pembayaran diproses melalui payment gateway resmi berlisensi. Data pribadi dan transaksi Anda dijaga kerahasiaannya.",
  },
  {
    q: "Bagaimana jika dana terpotong tetapi status tagihan belum berubah?",
    a: "Status pembayaran umumnya diperbarui otomatis dalam beberapa menit. Jika setelah beberapa saat belum berubah, hubungi kami dengan menyertakan bukti transaksi agar dapat kami periksa.",
  },
  {
    q: "Bagaimana cara mengajukan pengembalian dana (refund)?",
    a: "Silakan baca halaman Kebijakan Refund kami, lalu hubungi kami melalui email atau WhatsApp dengan menyertakan bukti transaksi.",
  },
  {
    q: "Apa itu uang jajan dan tabungan santri?",
    a: "Uang jajan digunakan santri untuk berbelanja di koperasi/kantin pesantren. Tabungan santri adalah simpanan yang dapat ditarik pada waktu tertentu (misal saat libur atau lulus) melalui persetujuan admin.",
  },
  {
    q: "Ke mana saya bisa menghubungi jika ada kendala?",
    a: `Anda dapat menghubungi kami melalui email ${SITE.email} atau WhatsApp ${SITE.phone} (${SITE.waName}).`,
  },
];

function Item({ q, a, idx }) {
  const [open, setOpen] = useState(idx === 0);
  return (
    <div className="border border-stone-200 rounded-xl bg-white overflow-hidden not-prose">
      <button
        onClick={() => setOpen((o) => !o)}
        data-testid={`faq-toggle-${idx}`}
        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left hover:bg-stone-50 transition-colors"
      >
        <span className="font-semibold text-stone-900">{q}</span>
        <ChevronDown
          size={18}
          className={`shrink-0 text-emerald-600 transition-transform ${open ? "rotate-180" : ""}`}
        />
      </button>
      {open && <p className="px-5 pb-5 -mt-1 text-stone-600 text-sm leading-relaxed">{a}</p>}
    </div>
  );
}

export default function Faq() {
  return (
    <PublicShell
      title="Pertanyaan yang Sering Diajukan (FAQ)"
      subtitle="Temukan jawaban atas pertanyaan umum seputar layanan kami."
    >
      <div className="space-y-3 not-prose" data-testid="faq-list">
        {FAQS.map((f, i) => (
          <Item key={i} idx={i} q={f.q} a={f.a} />
        ))}
      </div>
    </PublicShell>
  );
}
